import React from "react";
import "./doctor.css";

export default function Doctor() {
  return (
    <section className="doctors">
      <h1>
        Guest Lecturers / A<span style={{ color: "red" }}>IRD</span> TEAM
      </h1>
      <p className="main_text">
        Meet our team of experts healthcare professionals and researchers that
        start the <span style={{ color: "green" }}>PA</span>
        <span className="red">H</span>
        <span style={{ color: "green" }}>PO</span> vision
      </p>
      <ul className="doctors_wrapper">
        <li className="doctors_wrapper_item">
          <div className="image_container">
            <img src="/images/president.jpg" alt="doctor-1" />
            <div className="doctors_details">
              <p>Adewole Olakunle Tinws</p>
              <p>President / Founder</p>
              <span>president@ahpo.org</span>
            </div>
          </div>
        </li>

        <li className="doctors_wrapper_item">
          <div className="image_container">
            <img src="/images/co-founder-3.jpg" alt="doctor-1" />
            <div className="doctors_details">
              <p>Mohammed Muftawu</p>
              <p>Vice-President</p>
              <span>vice.president@ahpo.org</span>
            </div>
          </div>
        </li>
        <li className="doctors_wrapper_item">
          <div className="image_container">
            <img src="/images/co-founder.jpg" alt="doctor-1" />
            <div className="doctors_details">
              <p>Ojo Taiwo Abayomi</p>
              <p>Secretary</p>
              <span>secretary@ahpo.org</span>
            </div>
          </div>
        </li>
        <li className="doctors_wrapper_item">
          <div className="image_container">
            <img src="/images/co-founder_2.jpg" alt="doctor-1" />
            <div className="doctors_details">
              <p>Chama Tainada Harmis</p>
              <p>Financial Secretary</p>
              <span>chama.tainada@ahpo.org</span>
            </div>
          </div>
        </li>
        {/* <li className="doctors_wrapper_item">
          <div className="image_container">
            <img src="/images/doctor_1.jpg" alt="doctor-1" />
          </div>
        </li> */}
      </ul>
    </section>
  );
}
